
<template>
  <div style="width:100%;margin-top:0;"  >
    <formdialog 
        :form="form" 
        :dialog="startAuth" 
        :shadow="false"
        :model="{}"
        v-on:submitForm="signIn($event)"
        v-on:rejectForm="startAuth=false"
    ></formdialog>
    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>


  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import {FormPayload,Validator,FormStructField,Confirm} from '@/components/models/FormDialog'

  export default {
    name: 'SignUp',

    data:function(){
      return {
        alert:true,
        form:null,
        startAuth:false,
        showInProgressPanel:false
      }
    },
    computed: {
      ...mapState(
        {
            operationInProcess:'operationInProcess',
            operationInProcessMessage: 'operationInProcessMessage'
        }
      )
    },
    created:function(){
      this.buildForm(false)
      this.startAuth=true
    },

    methods:{
      signIn(credentials){
        let user = {
          email : credentials.groupName+"@dummy.com",
          password : credentials.password,
          username : credentials.groupName
        }
        this.$store.dispatch('authentication/signup',user).then(()=>{}).catch(()=>{})
      },
      buildForm:function(login){
        this.form = new FormPayload({
          title: (!login)?'Signup':'Login',
          block: true,
        });

        this.form.setConfirm(new Confirm({
          field1: 'password',
          field2: 'confirm'
        }));

        let field =  new FormStructField({
          name: 'groupName',
          label: 'Device group name',
          type: 'text',
          icon: 'person',
          hint: 'Name of your device group',
          meter: false
        });
        let validator = new Validator({
          regex: {value:'^([0-9A-Za-z]+)$'},
          required: true,
          min: 2,
          max: 20
        });
        field.setValidator(validator);

        this.form.addField(field);

        field =  new FormStructField({
          name: 'password',
          label: 'Password',
          type: 'password',
          hint: 'Password of your device group',
          icon: 'lock',
          meter: true
        });
        validator = new Validator({
          required: true,
          min: 6,
          max: 20,
          regex: {value:'^([0-9A-Za-z]+)$'}
        });
        field.setValidator(validator);

        this.form.addField(field);

        if(!login){
          field =  new FormStructField({
            name: 'confirm',
            label: 'Confirm Password',
            type: 'password',
            icon: 'lock',
            hint: 'Password of your device group',
            meter: false
          });
          validator = new Validator({
            required: true,
            min: 6,
            max: 20,
            regex: {value:''}
          });
          field.setValidator(validator);

          this.form.addField(field);
        }
      }
    }
  }
</script>

